import type { Palette } from "@brickme/project-core/src/model/picture.ts";
import type { AppState } from "~/store/root-reducer.ts";
import { ensureLoadedOnceOffLoad, isOnceOffLoaded } from "~/utils/loading.ts";
import type { HangingStrips } from "~/model.ts";

function selectPricingModel(state: AppState) {
	return state.reference.pricingModel;
}

/* @deprecated Use shopify prices instead */
function selectLoadedPricingModel(state: AppState) {
	return ensureLoadedOnceOffLoad(
		selectPricingModel(state),
		"Pricing model not loaded",
	);
}

function selectScenes(state: AppState) {
	return state.reference.scenes;
}

function selectShopifyCollections(state: AppState) {
	return state.reference.shopifyCollections;
}

function selectHasPricingModel(state: AppState): boolean {
	return isOnceOffLoaded(selectPricingModel(state));
}

function selectSystemPalette(state: AppState): Palette {
	return ensureLoadedOnceOffLoad(
		state.reference.systemPalette,
		"System palette not loaded",
	);
}

function selectBasePlateSizes(state: AppState) {
	return state.reference.basePlateSizes;
}

function selectAvailableBasePlateSizes(state: AppState) {
	const { basePlateSizes, restrictedBasePlateSizes } = state.reference;
	if (
		state.user.user.type === "signedIn" &&
		state.user.user.user.canUseRestrictedBaseplates
	) {
		return basePlateSizes;
	}
	return basePlateSizes.filter(
		(size) => !restrictedBasePlateSizes.includes(size),
	);
}

function selectSystemPaletteLoad(state: AppState) {
	return state.reference.systemPalette;
}

function selectCountriesLoad(state: AppState) {
	return state.reference.countries;
}

function selectShopifyShopDomain(state: AppState) {
	return state.reference.shopifyShopDomain;
}

function selectSystemPaletteLength(state: AppState) {
	return selectSystemPalette(state).length;
}

function selectPreassemblyProduct(state: AppState) {
	return state.reference.preassemblyProduct;
}

function selectHasSystemPalette(state: AppState) {
	return isOnceOffLoaded(state.reference.systemPalette);
}

function selectIsMobile(state: AppState): boolean {
	return state.reference.isMobile;
}

function selectBrowserSource(state: AppState) {
	return state.reference.browserSource;
}

function selectVersion(state: AppState): string {
	return state.reference.version;
}

function selectOperatingSystem(state: AppState) {
	return state.reference.os;
}

function selectHangingStripsData({
	reference: { hangingStrips },
}: AppState): HangingStrips | undefined {
	if (isOnceOffLoaded(hangingStrips)) {
		return hangingStrips.data;
	}
	return undefined;
}

function selectMaxNumberOfSelectableBasePlates(state: AppState) {
	return state.reference.maxNumberOfSelectableBasePlates;
}

export {
	selectCountriesLoad,
	selectMaxNumberOfSelectableBasePlates,
	selectScenes,
	selectHangingStripsData,
	selectBrowserSource,
	selectLoadedPricingModel,
	selectOperatingSystem,
	selectIsMobile,
	selectPreassemblyProduct,
	selectVersion,
	selectHasSystemPalette,
	selectSystemPaletteLoad,
	selectSystemPalette,
	selectSystemPaletteLength,
	selectPricingModel,
	selectHasPricingModel,
	selectBasePlateSizes,
	selectAvailableBasePlateSizes,
	selectShopifyCollections,
	selectShopifyShopDomain,
};
